export default __webpack_public_path__ + "static/media/defaultFile_ico.642994fe.svg";